import ForgotPasswordPopup from "./ForgotPasswordPopup";

export default ForgotPasswordPopup;
